import en from './en';
import zhTW from './zh-TW';

export const translations = {
  'en': en,
  'zh-TW': zhTW
};

export const languages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', nativeName: '繁體中文' }
];

export default translations;

